import { render, staticRenderFns } from "./view_doc_card.vue?vue&type=template&id=87547190&scoped=true"
import script from "./view_doc_card.vue?vue&type=script&lang=js"
export * from "./view_doc_card.vue?vue&type=script&lang=js"
import style0 from "./view_doc_card.vue?vue&type=style&index=0&id=87547190&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87547190",
  null
  
)

export default component.exports